const countryView = {
  en: {
    generalHeadline: "Explore top destinations around the world",
    bannerHeadlines: [
      "Experience everywhere your card can take you",
      "Accepted across more than 70 million places around the world",
      "Travel with confidence knowing your card is part of a global network",
    ],
    regionModules: {
      asiaPacific: {
        headline: "Asia Pacific",
        description:
          "Use your card almost everywhere in Japan as well as top travel destinations across Asia and Pacific Islands, including India, China, Singapore, Australia and more.",
        cta: "Traveling to Japan? ",
        links: [
          {
            city: "Tokyo",
            copy: "See the Tokyo Travel Guide",
          },
        ],
      },
      europe: {
        headline: "Europe",
        description:
          "You can use your card across some of Europe's most popular destinations, including Spain, Germany, the UK, Italy, Portugal and France.",
        cta: "Plus, explore travel guides for ",
        links: [
          {
            city: "Barcelona",
            copy: "Barcelona",
          },
          {
            city: "London",
            copy: "London",
          },
          {
            city: "Rome",
            copy: "Rome",
          },
          {
            city: "Lisbon",
            copy: "and Lisbon",
          },
        ],
      },
      middleEastAfrica: {
        headline: "Middle East & Africa",
        description:
          "Use your card in the UAE, Egypt, Morocco and South Africa. With destinations in the Middle East & Africa expanding rapidly, you can use your card in more and more places here.",
        cta: "Explore recommended places to visit with the ",
        links: [
          {
            city: "Dubai",
            copy: "Dubai Travel Guide",
          },
        ],
      },
      americas: {
        headline: "The Americas",
        description:
          "You can use your card across Canada, Mexico and the U.S., as well as in popular South American travel spots like Peru, Uruguay, Argentina, Chile and more.",
        cta: "Browse travel guides for ",
        links: [
          {
            city: "Cancun",
            copy: "Cancun",
          },
          {
            city: "Vancouver",
            copy: "Vancouver",
          },
          {
            city: "Toronto",
            copy: "Toronto",
          },
        ],
      },
    },
  },
};

export default countryView;
